var classes = {
  "root": "m_96b553a6"
};
export { classes as default };